import { Tooltip } from "@material-ui/core";
import React from "react";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import PageSpinner from "../../../../elements/spinner/PageSpinner";
import ExchangeProfitDetailsItem from "./ExchangeProfitDetailsItem";

import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../../styles/styledTable";
import { StyledTooltip } from "../../../../styles/styledTooltip";

const ExchangeProfitDetailsList = ({ exchanges, filterData, notification, setNotification }) => {
  const { t } = useTranslation("exchangerPage");

  if (!exchanges) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (exchanges.length === 0) {
    return <Alert severity="warning">{t("profitDetails.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable className="profit-details-list_scroll">
      <StyledTable
        width="1920"
        size="14"
        className="profit-list-table"
      >
        <StyledTableHead scroll="auto" col="12" className="profit-details-list__head">
          <div>
            Id
            <Tooltip
              title={t("profitDetails.table.tooltips.id")}
              arrow
              placement="top"
            >
              <StyledTooltip className="icon-light-help" />
            </Tooltip>
          </div>
          <div>
            {t("profitDetails.table.client")}
          </div>
          <div>
            {t("profitDetails.table.inService")}
          </div>
          <div>
            {t("profitDetails.table.inAmount")}
          </div>
          <div>
            {t("profitDetails.table.outService")}
          </div>
          <div>
            {t("profitDetails.table.outAmount")}
          </div>
          <div>
            {t("profitDetails.table.status")}
          </div>
          <div>
            {t("profitDetails.table.date")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {exchanges && exchanges.map((value, key) => (
            <ExchangeProfitDetailsItem
              key={key}
              filterData={filterData}
              value={value}
              notification={notification}
              setNotification={setNotification}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default ExchangeProfitDetailsList;